import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

import {createTransportationRatePolicy, getTransportationRatePolicy} from './api'
import {settingsKeys} from './query-keys'
import type {CreateTransportationRatePolicyInput} from './schemas'

export function useTransportationRatePolicy() {
    return useQuery({
        queryKey: settingsKeys.transportationRatePolicy(),
        queryFn: getTransportationRatePolicy,
    })
}

export function useCreateTransportationRatePolicy() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: CreateTransportationRatePolicyInput) =>
            createTransportationRatePolicy(input),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: settingsKeys.transportationRatePolicy(),
            })
        },
    })
}
